module.exports = __webpack_public_path__ + "img/delivery-icon.7952a044.png";